import React, { useEffect, useState, useMemo, useCallback } from 'react'
import DatePickerOrig, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'
import {
  CalendarWrap,
  CalendarControls,
  Calendar,
  LeftArrow,
  RightArrow,
  Button,
  LinkButton,
  CalendarHeader,
  CalendarHeaderDate,
  Placeholder,
  ContainerAbsolute,
  CalendarIcon,
  CloseIcon,
  StyledFieldTemplate
} from './DatePickerStyled'
import Popper, { Placement } from '../Popper'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import { fieldBase } from '../Form'

registerLocale('ru', ru)
const months = ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек']

type ValueType = Date | [Date | null, Date | null] | null

export interface DatePickerProps extends fieldBase<ValueType> {
  format?: string
  selectsRange?: boolean
  minDate?: Date
  maxDate?: Date
  popper?: boolean
  showMonthYearPicker?: boolean
  rangeSeparator?: string
  disabledСleaning?: boolean
  showTimeSelect?: boolean
  timeIntervals?: number
  timeFormat?: string
  dateFormat?: string
}

const CalendarContainer = (handleClose: any, handleApply: any) => {
  const CalendarContainerInner = ({ className, children }: any) => {
    return (
      <CalendarWrap className={className}>
        <Calendar>{children}</Calendar>
        <CalendarControls>
          <LinkButton onClick={handleClose}>Отменить</LinkButton>
          <Button onClick={handleApply}>применить</Button>
        </CalendarControls>
      </CalendarWrap>
    )
  }
  return CalendarContainerInner
}
CalendarContainer.displayName = 'CalendarContainer'
const calendarheader = ({ decreaseMonth, increaseMonth, date }: any) => {
  return (
    <>
      <CalendarHeader>
        <CalendarHeaderDate>
          {months[date.getMonth()]} {date.getFullYear()}
        </CalendarHeaderDate>
        <LeftArrow onClick={decreaseMonth} style={{ marginRight: 16 }} />
        <RightArrow onClick={increaseMonth} />
      </CalendarHeader>
    </>
  )
}
const PoperFabric = (poper: boolean) =>
  poper
    ? Popper
    : ({ modifiers, placement, target, ...props }: any) => (props.open ? <ContainerAbsolute {...props} /> : <></>)

const DatePicker = ({ popper = true, ...props }: DatePickerProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const [targetRef, setTargetRef] = useState<HTMLDivElement | undefined>()

  const [selectedDate, setSelectedDate] = useState<ValueType>(props.selectsRange ? [null, null] : null)

  const handleOpen = () => {
    if (!props.readOnly && !props.disabled) setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleApply = () => {
    const newValue: ValueType =
      selectedDate instanceof Array
        ? [
            selectedDate[0] ? (props.showTimeSelect ? selectedDate[0] : new Date(format(selectedDate[0], 'yyyy-MM-dd'))) : null,
            selectedDate[1]
              ? (props.showTimeSelect ? selectedDate[1] : new Date(format(selectedDate[1], 'yyyy-MM-dd')))
              : selectedDate[0]
              ? (props.showTimeSelect ? selectedDate[0] : new Date(format(selectedDate[0], 'yyyy-MM-dd')))
              : null
          ]
        : selectedDate
        ? (props.showTimeSelect ? selectedDate : new Date(format(selectedDate, 'yyyy-MM-dd')))
        : null

    if (props.onChange) {
      props.onChange(newValue)
    }

    handleClose()
  }

  const formatingDate = useCallback(
    (value: Date) => format(value, props.format || (props.showTimeSelect ? 'dd.MM.yyyy HH:mm' : 'yyyy-MM-dd'), { locale: ru }),
    [props.format, props.showTimeSelect]
  )

  const value: ValueType = useMemo(() => {
    return props.value || (props.selectsRange ? [null, null] : null)
  }, [props.value])

  useEffect(() => {
    setSelectedDate(value)
  }, [value])

  const [startDate, endDate] = selectedDate instanceof Array ? selectedDate : [selectedDate, undefined]
  const valueText =
    value instanceof Array && value[0]
      ? `${formatingDate(value[0])}${props.rangeSeparator ? props.rangeSeparator : ' - '}${
          value[1] ? formatingDate(value[1]) : ''
        }`
      : value instanceof Date
      ? `${formatingDate(value)}`
      : null
  const PopperElem = useMemo(() => PoperFabric(popper), [popper])
  return (
    <>
      <StyledFieldTemplate
        editabel={!props.readOnly}
        disable={props.disabled}
        className={props.className}
        active={isOpen}
        ref={(node: HTMLDivElement | undefined) => setTargetRef(node as HTMLDivElement | undefined)}
        onClick={handleOpen}
        style={props.style}
        empty={props.disabledСleaning || !valueText}
        error={props.error}
        errorText={props.errorText}
      >
        {valueText || <Placeholder>{props.placeholder || <>&nbsp;</>}</Placeholder>}
        <CalendarIcon />
        <CloseIcon
          onClick={(e) => {
            e.stopPropagation()
            if (props.onChange) {
              props.onChange(props.selectsRange ? [null, null] : null)
            }
          }}
        />
      </StyledFieldTemplate>
      <PopperElem
        open={Boolean(targetRef) && isOpen}
        targetRef={targetRef}
        placement={Placement.BottomStart}
        modifiers={[
          {
            name: 'flip',
            enabled: true
          }
        ]}
      >
        <div>
          <ClickAwayListener onClickAway={handleClose}>
            <DatePickerOrig
              locale="ru"
              onChange={(date) => setSelectedDate(date)}
              onMonthChange={(date) => !props.selectsRange && setSelectedDate(date)}
              startDate={startDate}
              selected={startDate}
              endDate={endDate}
              placeholderText={props.placeholder}
              calendarContainer={CalendarContainer(handleClose, handleApply)}
              renderCustomHeader={calendarheader}
              showPopperArrow={false}
              portalId="root-portal"
              inline
              selectsRange={props.selectsRange}
              minDate={props.minDate}
              maxDate={props.maxDate}
              showMonthYearPicker={props.showMonthYearPicker}
              showTimeSelect={props.showTimeSelect}
              timeIntervals={props.timeIntervals || 60}
              timeFormat={props.timeFormat || 'HH:mm'}
              dateFormat={props.dateFormat || (props.showTimeSelect ? 'dd.MM.yyyy HH:mm' : undefined)}
              timeCaption={props.showTimeSelect ? 'Время' : undefined}
            />
          </ClickAwayListener>
        </div>
      </PopperElem>
    </>
  )
}

export default DatePicker
